import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Utility } from '../core/common';
import { SharedService } from './shared.service';
import { Store } from '@ngxs/store';
import { AnalyticsService } from './analytics.service';
import { Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';
import { cachedObservable } from '../core/cached-observable';
import { CommunicationEventService } from './communication-event.service';
import { PaymentProvider, UserCriteria, VanguardPackage } from '../common';
import { firstValueFrom } from 'rxjs';
// import { AbTestService } from './ab-test.service';

const selectedSeekerIdTobuyKey = 'kp-user.service.selectedSeekerIdToBuy';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  ReadyToWorkBasePrice = 143000;

  vanguardPromoteVersion = 5;
  vanguardBasePrice = 242000;
  private _vanguardPackages: VanguardPackage[] = [
    //V5.4
    new VanguardPackage(`بسته پیشتاز`, '', 30, 1, 0, this.vanguardBasePrice, [
      'بهبود رزومه توسط کارشناس',
      'بسته پیشتاز به مدت یک ماه'
    ], true),
    // //V5.3
    // new VanguardPackage(`بسته پیشتاز`, '', 30, 1, 0, this.vanguardBasePrice, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ], true),
    // //V5.2
    // new VanguardPackage(`بسته پیشتاز`, '', 20, 1, 0, this.vanguardBasePrice, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ], true),
    //V5.1
    // new VanguardPackage(`بسته پیشتاز`, '', 10, 1, 0, this.vanguardBasePrice, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ], true, 65000),
    // new VanguardPackage(`بسته پیشتاز`, '', 11, 1, 7, 59000, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ]),
    // new VanguardPackage(`بسته پیشتاز`, '', 12, 1, 15, 69000, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ]),


    // //V5.0
    // new VanguardPackage('بسته پیشتاز یک هفته‌ای', 'fade-green-bg', 1, 0, 7, 25000),
    // new VanguardPackage(`بسته پیشتاز عادی`, '', 2, 1, 0, 59000, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت یک ماه'
    // ]),
    // new VanguardPackage(`بسته پیشتاز نقره‌ای`, '', 3, 2, 0, 91000, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت دو ماه',
    //   'ورود به لیست معرفی به کارفرما'
    // ], true),
    // new VanguardPackage(`بسته پیشتاز طلایی`, '', 4, 4, 0, 150000, [
    //   'بهبود رزومه توسط کارشناس',
    //   'بسته پیشتاز به مدت چهار ماه',
    //   'ورود به لیست معرفی به کارفرما',
    //   'اولویت بالا در معرفی به کارفرما'
    // ]),
  ];
  vanguardPackages: VanguardPackage[] = [this._vanguardPackages[0]];

  static SeekerPipelineStages = [
    { _collapsed: true, key: "unknown", title: "تعیین تکلیف" },
    { key: "lead", title: "سرنخ", description: "بررسی اولیه شرایط کارجو" },
    { key: "call", title: "تماس اولیه", description: "تماس با کارجو و دریافت اطلاعات" },
    { key: "process", title: "انتخاب کارفرما", description: "در انتظار یافتن کارفرما مناسب برای کارجو" },
    { key: "track", title: "دریافت تعرفه", description: "در انتظار دریافت تعرفه کاریابی از حقوق اول" }
  ];
  static jobTypes = ['تمام‌وقت', 'پاره‌وقت', 'پروژه‌ای', 'کاراموزی', 'دورکاری'];

  // private abTestKey = 'vanguard-price-azar02-5';
  constructor(private http: HttpClient, private store: Store, private sharedService: SharedService, private eventLog: CommunicationEventService,
    private numberPipe: DecimalPipe, private analyticsService: AnalyticsService, /*private abTest: AbTestService,*/ private router: Router) {
    // if (sharedService.isBrowser) {
    //   abTest.defineTest(this.abTestKey, ['10', '11']);
    //   let abTestVanguardPackage = abTest.getVariant(this.abTestKey).split('-').map(_ => +_);
    //   this.vanguardPackages = this._vanguardPackages.filter(_ => abTestVanguardPackage.includes(_.Id));
    // }
    // else
    //   this.vanguardPackages = this._vanguardPackages;
    // this.vanguardBasePrice = this.vanguardPackages[0].Price;

    // if (this.vanguardPackages.length > 1)
    //   this.vanguardPackages.forEach(_ => {
    //     var org = this.vanguardBasePrice / 7 * (_.Months * 30 + _.Days);
    //     _._Percent = (org - _.Price) / org;
    //   });
  }

  get currentUser() {
    return this.store.selectSnapshot(state => state.auth.user);
  }


  getAdmin(id: string) {
    return this.http.get<any>(environment.app.apiUrl + `user/admin/${id}?cb=${Date.now()}`).toPromise();
  }

  getBySeekerCode(code: number) {
    return this.http.get<any>(environment.app.apiUrl + 'user/seeker/' + code).toPromise();
  }
  getResumeInlineHtml(code: number, template = '', mobile = false) {
    return this.http.get<{ css: string, body: string }>(environment.app.apiUrl + `user/resume/inline/${code}`,
      { params: Utility.removeEmpty({ template, mobile }) }).toPromise();
  }
  getResumeFile(code: any, format: ('pdf' | 'image') = 'pdf', template = '', mobile = false) {
    return this.http.get(environment.app.apiUrl + `user/resume/${format}/${code}`,
      { params: Utility.removeEmpty({ template, mobile }), responseType: 'arraybuffer' }).toPromise();
  }

  getByEmployerCode(code: number) {
    return this.http.get<any>(environment.app.apiUrl + 'user/employer/' + code).toPromise();
  }

  getByAgentCode(code: number) {
    return this.http.get<any>(environment.app.apiUrl + 'user/agent/' + code).toPromise();
  }

  adminGetServiceRequests(criteria: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/admin/service/requests`, criteria).toPromise();
  }
  agentPanelGetSeekers(criteria: UserCriteria, from = 0, limit = 30, getTasks = false) {
    return this.http.post<{ total: number; users: any[], tasks?: any[] }>(environment.app.apiUrl + `user/agent/panel/seekers`, { criteria, from, limit, getTasks })
      .toPromise();
  }
  saveKarpashaSettings(settings: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/karpsha/save-settings`, settings).toPromise();
  }
  adminGetList(criteria: UserCriteria, from = 0, limit = 30) {
    return this.http.post<{ total: number; users: any[] }>(environment.app.apiUrl + `user/admin/list/${from}/${limit}`, criteria)
      .toPromise();
  }
  adminGetByIds(ids: string[]) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/admin/ids`, ids).toPromise();
  }
  assignAgent(agentCode: string, accept: boolean, note: string = '', jobs: string[] = null) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/assign-agent`, { agentCode, note, jobs, accept }).toPromise();
  }
  AdminAssignAgent(seekerIds: any[], agentId: string, status: string, note: string = '', jobs: string[] = null) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/admin/assign-agent`, { agentId, seekerIds, status, note, jobs }).toPromise();
  }
  adminChangeAgent(seekerId: any, oldAgentId: string, newAgentId: string) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/admin/change-agent`, { seekerId, oldAgentId, newAgentId }).toPromise();
  }
  AdminRemoveAgent(seekerId: string, agentId: string) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/admin/remove-agent`, { agentId, seekerId }).toPromise();
  }
  AgentChangeStatus(seekerId: string, agentId: string, status: string, note: string = '', jobs: string[] = null) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/agent/assign-seeker`, { agentId, seekerIds: [seekerId], status, note, jobs }).toPromise();
  }
  agentSaveAgentData(seekerId: string, agentData: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/agent/save-data`, { seekerId, agentData }).toPromise();
  }
  agentSaveActivity(agentId: any, activity: any) {
    return this.http.post<{ seeker: any, activity: any }>(environment.app.apiUrl + `user/agent/save-activity`, { agentId, activity }).toPromise();
  }

  seekerSaveAgentData(seekerId: string, agentData: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/seeker/save-agent-data`, { seekerId, agentData }).toPromise();
  }


  getSeekersByIds(ids: string[]) {
    return this.http.post<any[]>(environment.app.apiUrl + `user/seeker/ids`, ids).toPromise();
  }
  search(criteria: UserCriteria, from = 0, limit = 30) {
    return this.http.post<{ total: number; users: any[] }>(environment.app.apiUrl + `user/admin/list/${from}/${limit}`, criteria);
  }

  educationFields() {
    return this.http.get<string[]>(environment.app.apiUrl + `user/education/fields`).toPromise();
  }

  async searchAgent(criteria: UserCriteria, from = 0, limit = 30) {
    return this.http.post<{ total: number; users: any[] }>(environment.app.apiUrl + `user/agent/search/${from}/${limit}`, criteria)
      .toPromise();
  }
  countAgentsFilter(): any {
    return this.http.get(environment.app.apiUrl + 'user/agent/count').toPromise();
  }

  async searchSeeker(criteria: UserCriteria, from = 0, limit = 30) {
    return this.http.post<{ total: number; users: any[] }>(environment.app.apiUrl + `user/seeker/search/${from}/${limit}`, criteria)
      .toPromise();
  }

  async searchEmployer(criteria: UserCriteria, from = 0, limit = 30) {
    return this.http.post<{ total: number; users: any[] }>(environment.app.apiUrl + `user/employer/search/${from}/${limit}`, criteria)
      .toPromise();
  }

  async searchSeekerMetadata(criteria: UserCriteria) {
    return this.http.post<{ total: number; seekerSearchMetadata: any }>(environment.app.apiUrl + `user/seeker/search/metadata`, criteria).toPromise();
  }

  getSeekerFull(userId: string) {
    return this.http.get<any>(environment.app.apiUrl + `user/seeker/full/${userId}`).toPromise();
  }

  buyResume(userId: string) {
    return this.http.get<any>(environment.app.apiUrl + `user/seeker/buy/${userId}`).toPromise();
  }

  async buyResumeCredit(seekerIds: string[], discountId?: string) {
    const redirect: any = await this.http.post(environment.app.apiUrl + `user/buy-resume/${discountId || ''}`,
      seekerIds, { params: Utility.removeUndefined({ _v: 1 }) }).toPromise();
    location.href = redirect.link;
  }


  // Operator
  async addCredit(userId: string, amount: number, itemId?: string) {
    return await this.http.post(environment.app.apiUrl + `user/credit/add`, { userId, amount, itemId }).toPromise();
  }

  async addResumeCredit(userId: string, amount: number, itemId?: string) {
    return await this.http.post(environment.app.apiUrl + `user/resumecredit/add`, { userId, amount, itemId }).toPromise();
  }
  async addNotCompletedResumeCredit(userId: string, amount: number, itemId?: string) {
    return await this.http.post(environment.app.apiUrl + `user/NotCompletedResumeCredit/add`, { userId, amount, itemId }).toPromise();
  }

  nearbySeeker(where: string, what: string, distance = 100, from = 0, limit = 30) {
    return this.http.get<{ total: number; users: any[] }>(environment.app.apiUrl + `user/seeker/nearby`, {
      params: {
        l: where || '', q: what || '', from: from.toString(),
        limit: limit.toString(), distance: distance.toString()
      }
    }).toPromise();
  }

  // addCv(file: File, onprogress?: (progress: number) => void) {
  //   const formData = new FormData();
  //   formData.append('file', file, file.name);
  //   return new Promise<any>(resolve => {
  //     this.http.post<any>(environment.app.apiUrl + 'user/seeker/cv', formData, { reportProgress: true, observe: 'events' })
  //       .subscribe(event => {
  //         switch (event.type) {
  //           case HttpEventType.UploadProgress:
  //             if (onprogress) onprogress(Math.round(100 * event.loaded / event.total));
  //             break;
  //           case HttpEventType.Response:
  //             this.store.dispatch(Current);
  //             resolve(event.body);
  //             break;
  //         }
  //       });
  //   });
  // }

  // removeCv() {
  //   return new Promise(async resolve => {
  //     await this.http.delete(environment.app.apiUrl + 'user/seeker/cv').toPromise();
  //     this.store.dispatch(Current);
  //     resolve();
  //   });
  // }

  // getCv() {
  //   return this.http.get<any>(environment.app.apiUrl + 'user/seeker/cv').toPromise();
  // }

  async saveResume(user: any, wizardCompleted = false) {
    let result = await (this.http.post<any>(environment.app.apiUrl + 'user/resume/save' + (wizardCompleted ? '/true' : ''), user).toPromise());
    if (!user.Seeker?.IsAcceptable && result?.Seeker?.IsAcceptable) {
      this.eventLog.log(this.eventLog.actions.resume.seeker.becameAcceptable, {
        Data: { url: window.location.href, completeness: result.Seeker.Completeness, promoted: result.Seeker.ExpiredPromote ? "false" : "true" }
      });
    }
    return result;
  }

  async deleteResume(userId?: string) {
  return this.http
    .post(environment.app.apiUrl + 'user/resume/delete' + (userId ? `/${userId}` : ''), null)
    .toPromise();
  }
  agreement(agreement: string) {
    return this.http.post(environment.app.apiUrl + 'user/agreement/' + agreement, {}).toPromise();
  }

  adminSave(user: any) {
    return this.http.post<any>(environment.app.apiUrl + 'user/save', user).toPromise();
  }

  update(user: any) {
    return this.http.post<any>(environment.app.apiUrl + 'user/update', user).toPromise();
  }

  async vanguardPay(id: number, discountId: string, manualToken?: string, page?: string, url?: string) {
    url = url || location.href;

    this.analyticsService.gtmEvent('vanguard-paying', 'seeker');
    const response: any = await this.http.post(environment.app.apiUrl + 'user/vanguard/pay',
      { id, discountId, page, url, manual: manualToken, /*abTest: this.abTest.getAbTests(),*/ _v: this.vanguardPromoteVersion },
      { headers: { 'x-kp-alive': 'true' } }
    ).toPromise();
    if (response.provider == PaymentProvider.Manual)
      this.router.navigate([], { queryParams: { pid: response.id }, queryParamsHandling: 'merge' })
        .then(() => location.reload());
    else location.href = response.link;
  }

  async readytoworkPay(id: string, discountId: string, manualToken?: string, page?: string, url?: string) {
    this.analyticsService.gtmEvent('readytowork-paying', 'seeker');
    const response: any = await this.http.post(environment.app.apiUrl + 'user/readytowork/pay',
      { id, discountId, page, url, manual: manualToken },
      { headers: { 'x-kp-alive': 'true' } }
    ).toPromise();
    if (response.provider == PaymentProvider.Manual)
      this.router.navigate([], { queryParams: { pid: response.id }, queryParamsHandling: 'merge' })
        .then(() => location.reload());
    else location.href = response.link;
  }

  uploadPhoto(image: File, userId?: string) {
    const formData = new FormData();
    formData.append('image', image, image.name);
    return this.http.post<any>(environment.app.apiUrl + 'user/photo/upload' + (userId ? (`/${userId}`) : ''), formData).toPromise();
  }
  removePhoto(userId?: string) {
    return this.http.post(environment.app.apiUrl + 'user/photo/remove' + (userId ? (`/${userId}`) : ''), null).toPromise();
  }
  uploadCv(file: File, userId?: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post(environment.app.apiUrl + 'user/cv/upload' + (userId ? (`/${userId}`) : ''), formData).toPromise();
  }
  removeCv(userId?: string) {
    return this.http.post(environment.app.apiUrl + 'user/cv/remove' + (userId ? (`/${userId}`) : ''), null).toPromise();
  }
  uploadCompanyLogo(image: File) {
    const formData = new FormData();
    formData.append('image', image, image.name);
    return this.http.post(environment.app.apiUrl + 'user/company/logo/upload', formData).toPromise();
  }
  removeCompanyLogo() {
    return this.http.post(environment.app.apiUrl + 'user/company/logo/remove', null).toPromise();
  }
  uploadCompanyHeader(image: File) {
    const formData = new FormData();
    formData.append('image', image, image.name);
    return this.http.post(environment.app.apiUrl + 'user/company/header/upload', formData).toPromise();
  }
  removeCompanyHeader() {
    return this.http.post(environment.app.apiUrl + 'user/company/header/remove', null).toPromise();
  }

  eamployerDashboardData() {
    return this.http.get<any>(environment.app.apiUrl + `user/employer/dashboard-data`).toPromise();
  }

  getUserMessages(id: any): any {
    return this.http.get(environment.app.apiUrl + `user/messages/${id}`).toPromise();
  }
  getPushTokens(id: any): any {
    return this.http.get(environment.app.apiUrl + `user/push-tokens/${id}`).toPromise();
  }

  adminTagdJobTitles(id: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/admin/tag-jobtitles/${id}`, null).toPromise();
  }

  requestService(data: any) {
    return this.http.post(environment.app.apiUrl + 'user/service/request', data).toPromise();
  }

  get selectedSeekerIdsToBuy(): string[] {
    return JSON.parse(localStorage.getItem(selectedSeekerIdTobuyKey) || '[]');
  }
  set selectedSeekerIdsToBuy(value: string[]) {
    localStorage.setItem(selectedSeekerIdTobuyKey, JSON.stringify(value));
  }

  // avatar(userId: string, size: number = 28) {
  //   if (userId == null)
  //     return Promise.resolve(environment.app.url + '/assets/images/clipart/avatar-1.svg');
  //   return this.http.get<string>(environment.app.apiUrl + `user/avatar/${userId}/${size}`).toPromise();
  // }

  private static avatarsPromiseCache: { [key: string]: Promise<string> } = {};
  private static avatarsCache: { [key: string]: (resolve: string) => void } = {};
  private static getAvatarBucket: { [key: number]: string[] } = {};
  private static getAvatarTimeout: any;
  private defaultAvatar = environment.app.url + '/assets/images/clipart/avatar-1.svg';
  avatar(id: string, size: number = 28) {
    if (id == null) return Promise.resolve(this.defaultAvatar);

    var key = `${id}:${size}`;
    if (!UserService.avatarsPromiseCache[key])
      UserService.avatarsPromiseCache[key] = new Promise<any>(resolve => {
        UserService.avatarsCache[key] = resolve;
        clearTimeout(UserService.getAvatarTimeout);
        UserService.getAvatarTimeout = setTimeout(() => {
          var ids = UserService.getAvatarBucket[size];
          UserService.getAvatarBucket[size] = [];
          this.http.post<{ [key: string]: string }>(environment.app.apiUrl + `user/avatar`, ids).toPromise()
            .then(result => {
              for (let _id in result)
                try { UserService.avatarsCache[`${_id}:${size}`](result[_id]); }
                catch { }
            });
        }, 1000);
      });

    if (!UserService.getAvatarBucket[size])
      UserService.getAvatarBucket[size] = [];
    if (!UserService.getAvatarBucket[size].includes(id))
      UserService.getAvatarBucket[size].push(id);

    return UserService.avatarsPromiseCache[key];
  }

  // operator
  clearance(id: string, refund: number) {
    return this.http.post(environment.app.apiUrl + `user/clearance/${id}/${refund}`, null).toPromise();
  }

  // operator
  stopKarpasha(id: string) {
    return this.http.post(environment.app.apiUrl + `user/stop/karpasha/${id}`, null).toPromise();
  }

  // operator
  changeUsername(id: string, newUsername: string, skipMobileCheck: boolean) {
    return this.http.post<any>(environment.app.apiUrl + `user/change-username/${id}/${newUsername}/${skipMobileCheck}`, {}).toPromise();
  }
  changePassword(id: string, password: string) {
    return this.http.post<any>(environment.app.apiUrl + `user/change-password/${id}/`, { password: password }).toPromise();
  }

  suggest(includeOrder: boolean, includeAgent?: boolean, searchParams?: any) {
    // search = search ? `/${encodeURIComponent(search)}` : '';
    return this.http.get<any>(environment.app.apiUrl + `user/suggest`, {
      params: { search: JSON.stringify(searchParams), includeOrder }
    }).toPromise();
    //return this.http.post<any>(environment.app.apiUrl + `user/suggest`, { search: searchParams, includeOrder, includeAgent }).toPromise();
  }
  suggestByUser(userId: string, includeOrder = true, size = 100, projection?: string) {
    return this.http.post<any>(environment.app.apiUrl + `user/suggest-by-user/${userId}/${includeOrder}/${size}`, {}, {
      params: Utility.removeEmpty({ projection })
    }).toPromise();
  }

  suggestParam() {
    return this.http.post<any>(environment.app.apiUrl + `user/suggest-params`, {}).toPromise();
  }


  karpashas$ = cachedObservable<any[]>(this.http, 'userService', 'karpashas',
    environment.app.apiUrl + `user/karpasha-list`, this.sharedService.log
  );

  async sendDeleteAccountCode() {
    return this.http.get(environment.app.apiUrl + `user/delete-account`).toPromise();
  }
  async deleteAccount(code: string) {
    return this.http.post(environment.app.apiUrl + `user/delete-account`, code).toPromise();
  }
  getCurrentGeneralPoll(poll: string) {
    return this.http.get(environment.app.apiUrl + `user/general-poll/current`, { params: { poll: poll } }).toPromise();
  }
  saveGeneralPoll(data: any) {
    return this.http.post(environment.app.apiUrl + `user/general-poll/save`, data).toPromise();
  }

  async payKaryar(amount: number) {
    const response: any = await this.http.get(environment.app.apiUrl + `user/karyar/pay/${amount}`,
      { params: Utility.removeUndefined({ 'rb': location.href }), headers: { 'x-kp-alive': 'true' } }
    ).toPromise();

    if (response.provider == PaymentProvider.Manual)
      this.router.navigateByUrl(`/seeker/karpasha?pid=${response.id}`)
    // .then(() => location.reload());
    else location.href = response.link;
  }

  async payAgentRegistration(manualToken?: string) {
    const response: any = await this.http.get(environment.app.apiUrl + `user/agent-registration/pay`,
      { params: Utility.removeUndefined({ 'rb': location.href, 'manual': manualToken || undefined, _v: 1/*agentRegisterationVersion*/ }), headers: { 'x-kp-alive': 'true' } }
    ).toPromise();

    if (response.provider == PaymentProvider.Manual)
      this.router.navigateByUrl(`/seeker/karpasha?pid=${response.id}`)
    // .then(() => location.reload());
    else location.href = response.link;
  }
  async makeAgentRegistrationPayment() {
    return this.http.get<any>(environment.app.apiUrl + `user/agent-registration/make-payment`,
      { params: { 'rb': location.href, _v: 1/*agentRegisterationVersion*/ }, headers: { 'x-kp-alive': 'true' } }
    ).toPromise();
  }

  getSeekerSummaryFields(user: any): { key: string, value: string }[] {
    return [
      {
        key: 'حقوق', value: (user.MinSalary || user.MaxSalary)
          ? 'حقوق ' + [user.MinSalary ? this.numberPipe.transform(user.MinSalary) : undefined, user.MaxSalary ? this.numberPipe.transform(user.MaxSalary) : undefined].join(' - ').replace(/^[\s-]+/, '').replace(/[\s-]+$/, '') + ` تومان`
          : undefined
      },
      // {
      //   key: 'پرداخت', value: job.PaymentTypeString
      //     || Utility.distinct(<string[]>job.PaymentText)?.splice(0, 3)?.join(' و ')
      // },
      { key: 'بیمه', value: user.HasInsurance ? 'بیمه دارد' : undefined },
      { key: 'دورکاری', value: user.IsRemote ? 'امکان دورکاری' : undefined },
      { key: 'جنسیت', value: user.Gender == 0 ? 'فقط آقا' : user.Gender == 1 ? 'فقط خانم' : undefined },
      { key: 'نحوه همکاری', value: user.JobTypes?.join(' - ') },
      { key: 'تحصیلات', value: user.Educations?.length ? 'مدرک ' + user.Educations?.join(' - ') : undefined },
      { key: 'سابقه کاری', value: user.MinExperienceYear > 0 ? `${user.MinExperienceYear} سال سابقه` : user.MinExperienceYear == 0 ? 'بدون نیاز به سابقه' : undefined },
      { key: 'تعداد مورد نیاز', value: user.Vacancies > 1 ? `استخدام ${user.Vacancies} نفر` : undefined },
      {
        key: 'بازه سنی', value: (user.MinAge || user.MaxAge)
          ? (user.MinAge ? `از ${user.MinAge} ` : '') + (user.MaxAge ? `تا ${user.MaxAge}` : '') + ' ساله'
          : undefined
      },
      { key: 'مزایا', value: user.Bonuses?.join(' - ') },
    ].filter(_ => _.value);
  }

  getStageTitle(stage: string) {
    return (UserService.SeekerPipelineStages.find(_ => _.key == stage)
      || UserService.SeekerPipelineStages.find(_ => _.key == 'unknown'))?.title
      || 'نامشخص';
  }


  async sendLinkSms(mobile: string, url: string, forWhat?: string, activity?: any) {
    return this.http.post(environment.app.apiUrl + `user/send-url/${mobile}`, { url, forWhat, activity }).toPromise();
  }
  async sendSupportSms(mobile: string, url: string, message: string, activity?: any, sendDate?: Date) {
    return this.http.post<any>(environment.app.apiUrl + `user/send-support-message/${mobile}`, { url, message, activity, sendDate }).toPromise();
  }
  operatorSaveSeekerPartial(user: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/operator/save-seeker-partial/${user.Id}`, user).toPromise();
  }
  operatorSaveEmployerPartial(user: any) {
    return this.http.post<any>(environment.app.apiUrl + `user/operator/save-employer-partial/${user.Id}`, user).toPromise();
  }

  transmit(userId: string, to: 'vanguard' | 'karpasha' | 'ready-to-work', from?: 'vanguard' | 'karpasha' | 'employer') {
    return this.http.post<any>(environment.app.apiUrl + `user/transmit`, { userId, to, from }).toPromise();
  }

  verifyPhone(mobile: string, nationalCode: string) {
    return firstValueFrom(this.http.post<any>(environment.app.apiUrl + `user/verify-mobile`, { mobile, nationalCode }));
  }

}
